var render, staticRenderFns
import script from "./fb_default_options.vue?vue&type=script&lang=js&"
export * from "./fb_default_options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e5714c')) {
      api.createRecord('99e5714c', component.options)
    } else {
      api.reload('99e5714c', component.options)
    }
    
  }
}
component.options.__file = "app/javascript/packs/components/form/fb_default_options.vue"
export default component.exports